import React, { useEffect, useMemo, useState } from "react";
import { ROUTES } from "constants/routes-path";
import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    Input,
    LightMode,
    Stack,
    Tab,
    Tabs,
    TabList,
    TabPanel,
    TabPanels,
    Text,
    useColorModeValue
} from "@chakra-ui/react";
import CardHeader from "components/Card/CardHeader";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
    checkErrors,
    maskCPF
} from "utils/forms-utils";
import { validateCPF } from "utils/utils"
import { SearchIcon } from "@chakra-ui/icons";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";

const QueriesDriversScoreHistory = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const textColor = useColorModeValue("gray.700", "white");
    const formSpacing = "30px";
    const translationKey = "queries";
    const formTranslationKey = `${translationKey}.form`;
    const formDirection = { sm: "column", md: "row" };
    const [formData, setFormData] = useState(undefined);
    const [inputError, setInputError] = useState({});

    const handleClickClearQuery = () => {
        setFormData(initFormData());
    };

    const ids = useMemo(
        () => ({
            cpfCondutor: "driver-cpf",
        }), []
    );

    const maskMap = {
        [ids.cpfCondutor]: maskCPF,
    };

    const initFormData = () => {
        return {
            [ids.cpfCondutor]: {
                value: "",
                validations: [{ required: true }],
            }
        };
    };

    const validatorMap = {
        [ids.cpfCondutor]: {
            validate: (v) => validateCPF(v),
            errorKey: 'invalid-cpf',
        },
    };

    const handleDriverCpfSearch = () => {
        navigate(ROUTES.transportManagementPath + ROUTES.searches + ROUTES.searchDriversHistory + ROUTES.searchCpf +`?valor=${formData[ids.cpfCondutor].value}`)
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        const maskedValue = maskMap[id] ? maskMap[id](value) : value;

        const newFormData = {
            ...formData,
            [id]: { ...formData[id], value: maskedValue },
        };

        setFormData(newFormData);

        const validator = validatorMap[id];
            let formValidationErrors = checkErrors({ formData: newFormData, inputError: inputError, name: id })
            if (validator) {
                if (!validator.validate(maskedValue)) {
                    formValidationErrors[id] = t(`${translationKey}.messages.errors.${validator.errorKey}`);
                } else {
                    delete formValidationErrors[id];
                }
            }
        setInputError(formValidationErrors);
    };

    useEffect(() => {
        setFormData(initFormData());
    },[]);

    return (
        <Flex gap="5" direction="column" minH="89vh" align="center" pt={{ sm: "150px", md: "90px" }}>
            {formData && (
                <Card overflowX={{ sm: "scroll", lg: "hidden" }}>
                    <CardHeader mb="40px">
                        <Text color={textColor} fontSize="lg" fontWeight="bold">
                            {t(`${translationKey}.title.query-drivers-score-history`)}
                        </Text>
                    </CardHeader>
                    <CardBody>
                        <Tabs>
                            <TabList mb="1em">
                                <Tab>{t(`${translationKey}.query-strategies.cpf`)}</Tab>
                            </TabList>

                            <TabPanels>
                                <TabPanel>
                                    <Stack spacing={formSpacing} direction={formDirection}>
                                        <FormControl isRequired isInvalid={inputError[ids.cpfCondutor]}>
                                            <Input
                                                fontSize="sm"
                                                id={ids.cpfCondutor}
                                                name={ids.cpfCondutor}
                                                value={formData[ids.cpfCondutor].value.toUpperCase()}
                                                maxLength="14"
                                                onChange={handleInputChange}
                                                placeholder={t(`${formTranslationKey}.fields.driver-cpf.placeholder`)}
                                            />
                                            <FormErrorMessage>
                                                {t(inputError[ids.cpfCondutor])}
                                            </FormErrorMessage>
                                        </FormControl>

                                        <LightMode>
                                            <Button
                                                px="10"
                                                variant="dark"
                                                fontSize="sm"
                                                isDisabled={!validateCPF(formData[ids.cpfCondutor].value)}
                                                leftIcon={<SearchIcon />}
                                                onClick={handleDriverCpfSearch}
                                                _hover={!validateCPF(formData[ids.cpfCondutor].value) ? {} : undefined}
                                            >
                                                {t("system.actions.search")}
                                            </Button>
                                        </LightMode>

                                        <LightMode>
                                            <Button
                                                px="10"
                                                variant="dark"
                                                fontSize="sm"
                                                isDisabled={!formData[ids.cpfCondutor].value}
                                                onClick={handleClickClearQuery}
                                                _hover={!formData[ids.cpfCondutor].value ? {} : undefined}
                                            >
                                                {t("system.actions.clear")}
                                            </Button>
                                        </LightMode>
                                    </Stack>
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </CardBody>
                </Card>
            )}
        </Flex>
    );
};

export default QueriesDriversScoreHistory;